import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const systemDashboardEditRoute: InvariantRoute = {
	name: 'system-dashboard-edit',
	path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
	query: ['maximized?'],
};
